/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

class FormFilter {
  constructor(form) {
    this.form = form;

    this.node = document.createElement("div");
    this.node.classList.add("form-filter");

    var formSchema = JSON.parse(form.schema);
    formSchema.map((i) => {
      var item = this.createFilterItem(i);
      if (!item) return;
      this.node.appendChild(item);
    });
  }

  createFilterItem(item) {
    return null;
    switch (item.type) {
      case "sign":
        return this.createSign(item);
      case "address":
        return this.createAddress(item);
      case "default":
        return this.createDefault(item);
      case "text":
        return this.createText(item);
      case "image":
      case "hr":
      case "multichoice":
      case "tel":
        return null;
      default:
        console.error(`Item type ${item.type} not implemented.`);
    }
  }

  getQuery() {
    var nodes = Array.from(this.node.children);
    var query = {};

    nodes.map((n) => {
      if (typeof n.getQuery !== "function") return;

      var nodeQuery = n.getQuery();

      //key is the form unique name of an input
      for (var key in nodeQuery) query[key] = nodeQuery[key];
    });

    if (Object.keys(query).length === 0) return null;

    return query;
  }

  createSign(item) {
    var node = document.createElement("div");
    node.classList.add("filter-sign");

    node.insertAdjacentHTML(
      "beforeend",
      `
            <label>${item.meta.label}</label>
            <span>Eine Unterschrift muss eine Mindestlänge haben, damit sie als eine vollständige Unterschrift gilt.</span>
            <select>
                <option value="-1">Alle</option>
                <option value="1">Unterschieben</option>
                <option value="0">Nicht Unterschieben</option>
            </select>
        `
    );

    var select = node.querySelector("select");

    node.getQuery = function () {
      var val = parseInt(select.value, 10);
      var res = {};

      if (val === -1) return res;

      res[item.meta.name] = val;
      return res;
    };
    return node;
  }

  createAddress(item) {
    //filter just by postalcodes

    var node = document.createElement("div");
    node.classList.add("filter-address");

    node.insertAdjacentHTML(
      "beforeend",
      `
            <label>${item.meta.label}</label>
            <span>Kommasepariert. Ohne Leerzeichen.</span>
            <textarea placeholder="26603,28327,..."></textarea>
        `
    );

    var textarea = node.querySelector("textarea");

    node.getQuery = function () {
      var val = textarea.value;
      var res = {};

      if (val.length === 0) return res;

      var res = {};
      res[item.meta.name] = {
        postalCode: val,
      };

      return res;
    };
    return node;
  }

  createText(item) {
    if (!item.meta.checkbox) return;

    var node = document.createElement("div");
    node.classList.add("filter-text");

    node.insertAdjacentHTML(
      "beforeend",
      `
            <label>${item.meta.label}</label>
            <select>
                <option value="-1">Alle</option>
                <option value="1">Ausgewählt</option>
                <option value="0">Nicht Ausgewählt</option>
            </select>
        `
    );

    var select = node.querySelector("select");

    node.getQuery = function () {
      var val = parseInt(select.value, 10);
      var res = {};

      if (val === -1) return res;

      res[item.meta.name] = val;
      return res;
    };
    return node;
  }

  createDefault(item) {
    var node = document.createElement("div");
    node.classList.add("filter-default");

    node.insertAdjacentHTML(
      "beforeend",
      `
            <label>${item.meta.label}</label>
            <ul></ul>
        `
    );

    var ul = node.querySelector("ul");

    item.data.map((input) => {
      var li = document.createElement("li");
      var liHTML = `<label>${input.label}</label>`;

      switch (input.type) {
        case "text":
        case "email":
        case "iban":
        case "number":
          liHTML += `<input name="${input.name}" type="${input.type}" />`;
          break;
        case "date":
          liHTML += `
                        <input placeholder="min" name="${input.name}_min" type="${input.type}" />
                        <input placeholder="max" name="${input.name}_max" type="${input.type}" />
                    `;
          break;
        case "select":
          liHTML += `
                        <select name="${input.name}">
                            <option value="-1">Alle</option>
                    `;

          var option = input.options.split(";");
          option.map((o) => (liHTML += `<option>${o}</option>`));

          liHTML += "</select>";
          break;
        default:
          console.error(`default input type ${input.type} not implemented.`);
      }

      li.insertAdjacentHTML("beforeend", liHTML);
      ul.appendChild(li);
    });

    node.getQuery = function () {
      var res = {};
      var inputs = Array.from(ul.querySelectorAll("input,select"));

      inputs.map((i) => {
        var name = i.name;
        var val = i.value;

        if (!val || val === "-1") return;

        var prefix = name.substr(0, name.length - 4);
        var suffix = name.substring(name.length - 4);

        switch (suffix) {
          case "_min":
          case "_max":
            suffix = suffix.substr(1); //remove the _
            if (!res[prefix]) res[prefix] = {};
            res[prefix][suffix] = val; //do not parse to int cause it is a datestring
            break;
          default:
            res[name] = val;
        }
      });
      return res;
    };
    return node;
  }
}
